import './BgDeco.scss'

export const BgDeco = () => {
    return (
        <div className={'bg-deco'}>
            <div className={'outer-circle'}/>
            <div className={'middle-circle'}/>
            <div className={'inner-circle'}/>
        </div>
    )
}